<div class="module-category-list">
    <div class="buttons">
        @if (userHasCUDPermission$ | async) {
            <div class="add-new-button">
                <app-button
                    [buttonType]="'secondary'"
                    [leftIcon]="'plus'"
                    [label]="'moduleCategoryList.buttons.new' | translate"
                    (click)="openAddModuleCategoryDialog()"
                ></app-button>
            </div>
        }
        <div class="archived">
            <mat-checkbox (change)="getModuleCategories($event.checked)" [color]="'primary'" [labelPosition]="'before'">
                {{ "moduleCategoryList.checkbox" | translate }}
            </mat-checkbox>
        </div>
    </div>

    <table mat-table [dataSource]="currentModuleCategories" class="mat-elevation-z0" matSort>
        <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "moduleCategoryList.column.reference" | translate }}
            </th>
            <td mat-cell *matCellDef="let moduleCategory">{{ moduleCategory.reference }}</td>
        </ng-container>

        <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "moduleCategoryList.column.order" | translate }}
            </th>
            <td mat-cell *matCellDef="let moduleCategory">{{ moduleCategory.order }}</td>
        </ng-container>

        <ng-container matColumnDef="customizable">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "moduleCategoryList.column.customizable" | translate }}
            </th>
            <td mat-cell *matCellDef="let moduleCategory">{{ moduleCategory.customizable }}</td>
        </ng-container>

        <ng-container matColumnDef="module-blueprints">
            <th mat-header-cell *matHeaderCellDef>
                {{ "moduleCategoryList.column.moduleBlueprints.columnName" | translate }}
            </th>
            <td mat-cell *matCellDef="let moduleCategory">
                <table mat-table [dataSource]="moduleCategory.moduleBlueprints" class="nested-table mat-elevation-z1">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "moduleCategoryList.column.moduleBlueprints.name" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let blueprint">{{ blueprint.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "moduleCategoryList.column.moduleBlueprints.status" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let blueprint">{{ blueprint.status }}</td>
                    </ng-container>

                    <ng-container matColumnDef="orderWeight">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "moduleCategoryList.column.moduleBlueprints.order" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let blueprint">{{ blueprint.orderWeight }}</td>
                    </ng-container>

                    <ng-container matColumnDef="module-variant-ids">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "moduleCategoryList.column.moduleBlueprints.moduleVariantIds" | translate }}
                        </th>
                        <!--                        FUNCTION IN TEMPLATE-->
                        <td mat-cell *matCellDef="let blueprint">{{ blueprint.moduleVariantIds.join(", ") }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedBlueprintColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedBlueprintColumns;"></tr>
                </table>
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ "moduleCategoryList.column.action" | translate }}</th>
            <td mat-cell *matCellDef="let moduleCategory">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'moduleCategoryList.tooltip.edit' | translate"
                            (click)="openEditModuleCategoryDialog(moduleCategory)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

